import angular from 'angular';

export const loadModule = () =>
  angular
    .module('app')
    .controller('QuickStartVideoModalCtrl', function QuickStartVideoModalCtrl(
      $scope,
      $uibModalInstance,
    ) {
      $scope.cancel = () => {
        $uibModalInstance.dismiss('cancel');
      };
    });
